module.exports = __webpack_public_path__ + "img/ex1.2f1cab88.png";